import { render, staticRenderFns } from "./StockMidBulkHistory.vue?vue&type=template&id=508ba376&scoped=true"
import script from "./StockMidBulkHistory.vue?vue&type=script&lang=js"
export * from "./StockMidBulkHistory.vue?vue&type=script&lang=js"
import style0 from "./StockMidBulkHistory.vue?vue&type=style&index=0&id=508ba376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508ba376",
  null
  
)

export default component.exports